export const getFinancialMonth = (month, financialYear) => {
  if (['January', 'February', 'March'].includes(month)) {
    const yearToAppend = financialYear.split('-')[1].substring(3);
    return `${month}'${yearToAppend}`;
  } else {
    const yearToAppend = financialYear.split('-')[0].substring(2);
    return `${month}'${yearToAppend}`;
  }
};

export const getCurrentMonth = () => {
  const now = new Date();
  const monthIndex = now.getMonth();

  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  return monthNames[monthIndex];
};
